import React from 'react';
import styles from './style.module.scss';

interface GradientOutlineGridBackgroundCardProps {
  children?: React.ReactNode;
  className?: string;
}

const GradientOutlineGridBackgroundCard: React.FC<GradientOutlineGridBackgroundCardProps> = ({ children, className }) => {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      {children}
    </div>
  );
};

export default GradientOutlineGridBackgroundCard;
